import React from "react";

import background from '@cover/wachstumstoppen/background-1.svg';
import WachstumStoppen from "../components/cover/animations/wachstumstoppen";

export const meta = {
	category: "stop",
	slug: "wachstumstoppen",
	id: "WachstumStoppen",
	name: "wachstumstoppen",
	excerpt: {
		before: "Alternativen zum Neukauf"
	},
	title: "8 clevere Alternativen zum Neukauf",
	animation: WachstumStoppen,
	cover: {
		background: {
			lg: background,
			sm: background
		},
		alt: "Klickbuttons übersähen die Bildfläche und ringen untereinander um Sichtbarkeit. Auf jedem einzelnen von ihnen steht 'Kaufen'."
	}
}

const WachstumstoppenArticle = () => {
	return (
		<div>
			<ol className="articleList articleList--ordered">
				<li className="articleListItem">Verzichten</li>
				<li className="articleListItem">Bestandsaufnahme</li>
				<li className="articleListItem">Reparieren</li>
				<li className="articleListItem">Selber machen</li>
				<li className="articleListItem">Ausleihen oder mieten</li>
				<li className="articleListItem">Tauschen</li>
				<li className="articleListItem">Sich beschenken lassen</li>
				<li className="articleListItem">Secondhand kaufen</li>
			</ol>
		</div>
	)
};

export default WachstumstoppenArticle;